import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../contexts/AuthContext";
import * as api from "../services/api";
import styles from "./LanguageSwitcher.module.css";

const HEADER_LANGS = [
  { code: "es", label: "ES" },
  { code: "fr", label: "FR" },
  { code: "en", label: "EN" },
  { code: "pt", label: "PT" },
] as const;

const LanguageSwitcher: React.FC = () => {
  const { i18n, t } = useTranslation();
  const { artist } = useAuth();
  const [searchParams] = useSearchParams();
  const currentLang = i18n.language.split("-")[0];

  const handleLanguageChange = async (langCode: string) => {
    i18n.changeLanguage(langCode);

    const clientId = searchParams.get("clientId");
    if (clientId) {
      try {
        await api.updateNotificationSettings(clientId, { language: langCode });
      } catch {
        /* optional */
      }
    }
    if (artist?.id) {
      try {
        await api.updateBranding(artist.id, { language: langCode });
      } catch {
        /* optional */
      }
    }
  };

  return (
    <nav className={styles.lang} aria-label={t("languageSwitcher.label", "Idioma")}>
      {HEADER_LANGS.map((lang) => {
        const active = currentLang === lang.code;
        return (
          <button
            key={lang.code}
            type="button"
            onClick={() => handleLanguageChange(lang.code)}
            className={active ? styles.on : undefined}
            aria-current={active ? "true" : undefined}
          >
            {lang.label}
          </button>
        );
      })}
    </nav>
  );
};

export default LanguageSwitcher;
